import React from 'react';
import { Box, Button } from '@mui/material';
import './RequestSubTitle.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function RequestSubTitle({
    title,
    path,
    cardValue,
    cardtitle,
    buttonText,
    onButtonClick
}) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const pathMap = {
        Organizations: "/org",
        Routes: "/route",
        Vehicles: "/vehicle",
        Sites: "/site",
        Stops: "/stop",
        Users: "/user",
        Schedules: "/schedule",
        Reports: "/reports",
        "Manage Roles": "/user/role",
    };

    const renderBreadcrumbs = (path) => {
        const segments = path ? path.split(">").map(s => s.trim()) : [];
        return segments.map((segment, index) => {
            const isLast = index === segments.length - 1;
            const to = index === 0 ? "/dashboard" : pathMap[segment] || null;
            const isClickable = !isLast && to;

            return (
                <React.Fragment key={index}>
                    <span
                        style={{
                            cursor: isClickable ? "pointer" : "default",
                            color: isClickable ? "#1976d2" : "inherit",
                        }}
                        onClick={() => isClickable && navigate(to)}
                    >
                        {t(segment)}
                    </span>
                    {!isLast && <span> &gt; </span>}
                </React.Fragment>
            );
        });
    };

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        }
    };

    return (
        <div className="request-subtitle-container">
            <div className="request-subtitle-left">
                <Box>
                    <span className="request-subtitle-title">{t(title)}</span>
                    <span className="request-subtitle-path">{renderBreadcrumbs(path)}</span>
                </Box>
            </div>

            <div className="request-subtitle-right">
                <div className="request-subtitle-card">
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        textAlign: "center",
                        gap: "10px"
                    }}>
                        <span style={{
                            fontFamily: "Roboto",
                            fontWeight: 500,
                            fontSize: "20px",
                        }}>
                            {t(cardtitle)}
                        </span>
                        <span style={{ fontSize: "32px" }}>
                            {cardValue}
                        </span>
                    </div>
                </div>

                <button
                    className="request-subtitle-button"
                    variant="contained"
                    onClick={handleButtonClick}
                >
                    {t(buttonText)}
                </button>
            </div>
        </div>
    );
}